export const APPLICATION_TRUST_STATUS = {
  Unknown: 'Unknown',
  Trusted: 'Trusted',
  Untrusted: 'Untrusted',
  InProgress: 'InProgress',
};

const APPLICATION_TRUST_STATUS_MAPPING = [
  { value: APPLICATION_TRUST_STATUS.Unknown, label: 'No Status', color: '#9E9E9E' },
  { value: APPLICATION_TRUST_STATUS.Trusted, label: 'Trusted', color: '#4CAF50' },
  { value: APPLICATION_TRUST_STATUS.Untrusted, label: 'Untrusted', color: '#F44336' },
  { value: APPLICATION_TRUST_STATUS.InProgress, label: 'In Progress', color: '#FF9800' },
];

export const getApplicationTrustStatusLabel = value =>
  APPLICATION_TRUST_STATUS_MAPPING.find(item => item.value === value)?.label ??
  (value != null && value !== '' ? String(value).replace(/([a-z])([A-Z])/g, '$1 $2') : '');

export const getApplicationTrustStatusOptions = () =>
  APPLICATION_TRUST_STATUS_MAPPING.map(({ value, label }) => ({ value, label }));

export const getApplicationTrustStatusColor = value =>
  APPLICATION_TRUST_STATUS_MAPPING.find(item => item.value === value)?.color || '#9E9E9E';
